
export const isNotFalsy = (prop) => {
    return prop !== null && prop !== '' && prop !== undefined;
};

export const isFalsy = (prop) => {
    return prop === null || prop === '' || prop === undefined;
};
